import styled from "styled-components";

export const StyledMatchPromo = styled.div`
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  color: ${({ theme }) => theme.rgba.black_100_50};

  a:first-child {
    .mls-c-match-promo__promo-link-button {
      margin-top: 0px;
    }
  }
`;

export const StyledMatchPromoTitle = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.mixins.pxToRem(12)};
  font-weight: 700;
  line-height: ${({ theme }) => theme.mixins.pxToRem(18)};
`;

export const StyledMatchPromoDescription = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.mixins.pxToRem(12)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.mixins.pxToRem(18)};
`;
